// ─────────────────────────────────────────────────────────────────
// src/dump.ts
// ─────────────────────────────────────────────────────────────────

// Place institution images at src/assets/institutions/
import uapImg from "./assets/institutions/uap.png";
import stanbicImg from "./assets/institutions/stanbic.png";
import iceaImg from "./assets/institutions/icea.png";
import xenoImg from "./assets/institutions/xeno.png";
import sanlamImg from "./assets/institutions/sanlam.png";

export const InstitutionsData = [
  {
    id: 1,
    name: "UAP Old Mutual",
    type: "Asset Management",
    image: uapImg,
    brandColor: "#8B1A1A",
    tagline: "Securing your financial future across East Africa",
    description:
      "East Africa's leading wealth and investment manager with unit trust funds, retirement solutions, and insurance-linked products. Over UGX 850 billion in client assets.",
    about:
      "UAP Old Mutual is East Africa's leading wealth and investment manager, formed from the merger of UAP Holdings and Old Mutual's East African operations. They manage over UGX 850 billion in client assets across unit trust funds, pension schemes, and insurance-linked investment products.\n\nWith a presence in Kenya, Uganda, Tanzania, Rwanda, and South Sudan, UAP Old Mutual provides a comprehensive suite of financial services. Their Uganda unit trust operations are licensed by the Capital Markets Authority (CMA) and regulated by the Uganda Retirement Benefits Regulatory Authority (URBRA).\n\nTheir investment philosophy centres on disciplined asset allocation, rigorous risk management, and a deep understanding of East African economic cycles.",
    mission: "To be the most trusted partner for wealth creation, protection, and transfer in Africa.",
    website: "https://www.uapoldmutual.com",
    email: "invest@uapoldmutual.com",
    phone: "+256 312 291 000",
    rating: 4.8,
    total_funds_managed: "850000000000",
    total_investors: 12400,
    location: "Rwenzori Towers, Kampala",
    established_year: 2015,
    regulated_by: "Capital Markets Authority (CMA Uganda)",
    verified: true,
    created_at: "2024-01-15T10:30:00Z",
    updated_at: "2024-08-01T14:22:00Z",
    products: [
      {
        id: 101,
        name: "Money Market Fund",
        type: "Money Market",
        annual_rate: 11.5,
        min_investment: 100000,
        return_range: "10 – 12%",
        term: "No lock-in period",
        risk: "Low",
        description: "Invests in short-term government treasury bills, fixed bank deposits, and commercial paper. Interest is calculated daily and distributed monthly.",
        features: ["Daily interest accrual", "No withdrawal penalties", "Same-day redemption", "Minimum top-up: UGX 50,000"],
        example: { investment: 1000000, monthly_interest: 9583, annual_interest: 115000, value_after_1yr: 1115000 },
      },
      {
        id: 102,
        name: "Balanced Fund",
        type: "Balanced",
        annual_rate: 14,
        min_investment: 500000,
        return_range: "12 – 16%",
        term: "12+ months recommended",
        risk: "Medium",
        description: "Diversified fund blending Uganda Government Bonds (40–50%), equities listed on the USE (25–35%), and fixed deposits (15–25%).",
        features: ["Quarterly rebalancing", "Diversified across asset classes", "Suitable for 1–3 year goals", "Minimum top-up: UGX 200,000"],
        example: { investment: 1000000, monthly_interest: 11667, annual_interest: 140000, value_after_1yr: 1140000 },
      },
      {
        id: 103,
        name: "Equity Fund",
        type: "Equity",
        annual_rate: 18,
        min_investment: 1000000,
        return_range: "14 – 22%",
        term: "36+ months recommended",
        risk: "High",
        description: "Equity-focused fund investing in blue-chip companies on the Uganda Securities Exchange and select NSE stocks.",
        features: ["USE & NSE listed equities", "Professional stock selection", "Long-term capital growth", "Minimum top-up: UGX 500,000"],
        example: { investment: 1000000, monthly_interest: 15000, annual_interest: 180000, value_after_1yr: 1180000 },
      },
    ],
  },
  {
    id: 2,
    name: "Stanbic Unit Trust",
    type: "Unit Trust",
    image: stanbicImg,
    brandColor: "#003DA5",
    tagline: "It can be — grow your wealth with Stanbic",
    description: "Managed by Stanbic Investment Management Services (SIMS). One of the largest and most liquid funds in Uganda.",
    about: "Stanbic Unit Trust is managed by Stanbic Investment Management Services (SIMS), a subsidiary of Stanbic Bank Uganda, part of the Standard Bank Group — Africa's largest banking group by assets.\n\nThe fund range includes a Money Market Fund and Bond Fund. The Bond Fund has been particularly popular, consistently delivering returns above 13% per annum.\n\nAll funds are licensed by the Capital Markets Authority of Uganda. Client funds are held separately from the bank's balance sheet in custodian accounts.",
    mission: "To drive Africa's growth by providing accessible, high-quality investment solutions.",
    website: "https://www.stanbicbank.co.ug",
    email: "unittrustug@stanbic.com",
    phone: "+256 312 224 600",
    rating: 4.7,
    total_funds_managed: "650000000000",
    total_investors: 9800,
    location: "Crested Towers, Kampala",
    established_year: 2010,
    regulated_by: "Capital Markets Authority (CMA Uganda)",
    verified: true,
    created_at: "2024-01-10T10:00:00Z",
    updated_at: "2024-08-10T14:00:00Z",
    products: [
      {
        id: 201,
        name: "Bond Fund",
        type: "Bond Fund",
        annual_rate: 13.6,
        min_investment: 100000,
        return_range: "12 – 15%",
        term: "6+ months recommended",
        risk: "Low-Medium",
        description: "Invests primarily in medium to long-term Uganda Government Bonds and select corporate bonds. Consistently one of the best-performing bond funds in Uganda.",
        features: ["Government bond focused", "Consistent returns above 13%", "Quarterly income distribution", "Minimum: UGX 100,000"],
        example: { investment: 1000000, monthly_interest: 11333, annual_interest: 136000, value_after_1yr: 1136000 },
      },
      {
        id: 202,
        name: "Money Market Fund",
        type: "Money Market",
        annual_rate: 10.5,
        min_investment: 100000,
        return_range: "9 – 12%",
        term: "No lock-in period",
        risk: "Low",
        description: "Short-term fund investing in treasury bills and bank deposits. Offers daily liquidity with competitive returns.",
        features: ["Daily liquidity", "T-Bill focused", "Same-day access", "Minimum: UGX 100,000"],
        example: { investment: 1000000, monthly_interest: 8750, annual_interest: 105000, value_after_1yr: 1105000 },
      },
    ],
  },
  {
    id: 3,
    name: "ICEA Lion",
    type: "Asset Management",
    image: iceaImg,
    brandColor: "#B8860B",
    tagline: "Building wealth across generations",
    description: "Part of the ICEA Lion Group, one of East Africa's largest financial services conglomerates managing over UGX 340 billion.",
    about: "ICEA Lion Asset Management (Uganda) Limited is licensed by the Capital Markets Authority to provide fund management services. They manage the ICEA Lion Unit Trust with Money Market and Equity fund options.\n\nThe firm benefits from the wider ICEA Lion Group's research capabilities and pan-African investment expertise. Their investment committee includes seasoned professionals with deep knowledge of Ugandan government securities markets.\n\nICEA Lion is known for its conservative, risk-conscious approach and strong corporate governance.",
    mission: "To deliver consistent, risk-adjusted returns while preserving client capital.",
    website: "https://www.icealion.com",
    email: "assetmanagement@icealion.com",
    phone: "+256 417 232 100",
    rating: 4.5,
    total_funds_managed: "340000000000",
    total_investors: 5600,
    location: "Nakasero Road, Kampala",
    established_year: 2012,
    regulated_by: "Capital Markets Authority (CMA Uganda)",
    verified: true,
    created_at: "2024-01-20T14:45:00Z",
    updated_at: "2024-08-05T09:12:00Z",
    products: [
      {
        id: 301,
        name: "Money Market Fund",
        type: "Money Market",
        annual_rate: 11.3,
        min_investment: 500000,
        return_range: "10 – 12%",
        term: "No lock-in period",
        risk: "Low",
        description: "Invests in short-dated Uganda Government Treasury Bills, fixed deposits, and high-quality commercial paper.",
        features: ["Capital preservation focus", "T+1 redemption", "Monthly income distribution", "Minimum: UGX 500,000"],
        example: { investment: 1000000, monthly_interest: 9416, annual_interest: 113000, value_after_1yr: 1113000 },
      },
      {
        id: 302,
        name: "Equity Fund",
        type: "Equity",
        annual_rate: 18,
        min_investment: 1000000,
        return_range: "14 – 22%",
        term: "3+ years recommended",
        risk: "High",
        description: "Invests primarily in shares listed on the Uganda Securities Exchange and select NSE blue chips.",
        features: ["USE & NSE equities", "Professional stock selection", "Quarterly reporting", "Minimum: UGX 1,000,000"],
        example: { investment: 1000000, monthly_interest: 15000, annual_interest: 180000, value_after_1yr: 1180000 },
      },
    ],
  },
  {
    id: 4,
    name: "Xeno",
    type: "Digital Wealth Management",
    image: xenoImg,
    brandColor: "#00C9A7",
    tagline: "Investing made simple — start with UGX 10,000",
    description: "Uganda's first fully digital investment platform. Over 8,000 Ugandans use Xeno to save and grow their money.",
    about: "Founded in 2017, Xeno was built to solve a simple problem: most Ugandans have no access to quality investment products. Xeno changed that with a mobile-first platform that lets anyone invest from UGX 10,000.\n\nXeno portfolios are managed by a licensed fund manager (UAP Old Mutual) and invested in a mix of Uganda Government Securities, bank deposits, and offshore ETFs.\n\nXeno is licensed by the Capital Markets Authority of Uganda. Deposits are held in custodian bank accounts separate from company funds.",
    mission: "To give every Ugandan access to world-class investment management.",
    website: "https://www.myxeno.com",
    email: "hello@myxeno.com",
    phone: "+256 200 905 940",
    rating: 4.6,
    total_funds_managed: "120000000000",
    total_investors: 8200,
    location: "Bukoto Street, Kampala",
    established_year: 2017,
    regulated_by: "Capital Markets Authority (CMA Uganda)",
    verified: true,
    created_at: "2024-02-10T08:15:00Z",
    updated_at: "2024-07-28T11:30:00Z",
    products: [
      {
        id: 401,
        name: "Money Market Fund",
        type: "Money Market",
        annual_rate: 12,
        min_investment: 10000,
        return_range: "10 – 13%",
        term: "Withdraw anytime",
        risk: "Low",
        description: "Short-term savings portfolio invested in Uganda Treasury Bills and bank placements. Returns are 3–4x better than a bank savings account.",
        features: ["Start from UGX 10,000", "No lock-in period", "Mobile money deposits", "Automated monthly investing"],
        example: { investment: 1000000, monthly_interest: 10000, annual_interest: 120000, value_after_1yr: 1120000 },
      },
      {
        id: 402,
        name: "Growth Portfolio",
        type: "Equity Blend",
        annual_rate: 16,
        min_investment: 10000,
        return_range: "12 – 18%",
        term: "3+ years recommended",
        risk: "Medium-High",
        description: "Growth-oriented portfolio mixing Uganda Government Bonds, East African equities, and offshore ETFs.",
        features: ["Start from UGX 10,000", "Auto-rebalancing", "Goal-based investing", "Offshore diversification"],
        example: { investment: 1000000, monthly_interest: 13333, annual_interest: 160000, value_after_1yr: 1160000 },
      },
    ],
  },
  {
    id: 5,
    name: "Sanlam",
    type: "Asset Management",
    image: sanlamImg,
    brandColor: "#0072BC",
    tagline: "Wealthsmiths — crafting your financial future",
    description: "Part of Africa's largest financial services group (33 countries, USD 80B+ global AUM) offering unit trust funds in East Africa.",
    about: "Sanlam Investments East Africa is the regional fund management subsidiary of Sanlam Group, a South African financial services company with over 100 years of history and USD 80+ billion in global assets under management.\n\nIn Uganda, Sanlam offers CMA-licensed unit trust funds managed by a dedicated East African investment team combining global research with local market knowledge.\n\nSanlam is known for strong governance, transparent fee structures, and commitment to investor education.",
    mission: "To help people live with confidence by building and protecting their wealth.",
    website: "https://www.sanlaminvestments.com",
    email: "invest.ea@sanlam.com",
    phone: "+256 312 262 223",
    rating: 4.4,
    total_funds_managed: "280000000000",
    total_investors: 4800,
    location: "Acacia Mall, Kampala",
    established_year: 2014,
    regulated_by: "Capital Markets Authority (CMA Uganda)",
    verified: true,
    created_at: "2024-02-18T09:00:00Z",
    updated_at: "2024-07-15T10:30:00Z",
    products: [
      {
        id: 501,
        name: "Income Fund",
        type: "Income Fund",
        annual_rate: 13.1,
        min_investment: 100000,
        return_range: "12 – 14%",
        term: "6+ months recommended",
        risk: "Low-Medium",
        description: "Fixed income fund investing in Uganda Government Bonds and high-grade corporate paper. One of the best-performing income funds in the market.",
        features: ["Government bond focused", "Quarterly income payout", "Low volatility", "Minimum: UGX 100,000"],
        example: { investment: 1000000, monthly_interest: 10916, annual_interest: 131000, value_after_1yr: 1131000 },
      },
      {
        id: 502,
        name: "Balanced Fund",
        type: "Balanced",
        annual_rate: 14.5,
        min_investment: 250000,
        return_range: "12 – 16%",
        term: "12+ months recommended",
        risk: "Medium",
        description: "Balanced allocation across East African government securities, listed equities, and real estate investment trusts.",
        features: ["Pan-EA diversification", "REIT allocation", "Quarterly rebalancing", "Minimum: UGX 250,000"],
        example: { investment: 1000000, monthly_interest: 12083, annual_interest: 145000, value_after_1yr: 1145000 },
      },
    ],
  },
];

// Flat products list (backward compat)
export const productsData = InstitutionsData.flatMap((inst) =>
  (inst.products || []).map((p: any) => ({
    ...p,
    institution: inst.name,
    institution_id: inst.id,
    expected_return_min: parseFloat(p.return_range?.split("–")?.[0]) || 0,
    expected_return_max: parseFloat(p.return_range?.split("–")?.[1]) || 0,
    investment_term_months: p.term,
    risk_level: p.risk,
    status: "open",
    funding_percentage: 70,
    investors_count: Math.round(inst.total_investors / (inst.products?.length || 1)),
    created_at: inst.created_at,
  }))
);